import { memo } from 'react';
import { Controller } from 'react-hook-form';
import StoryblokSignatureComponent from '../StoryblokSignatureComponent';
import type { SignatureComponent } from '../../../types/customStoryblokComponents';

interface SignatureProps {
    params: SignatureComponent;
}

const Signature = ({ params: { name, _uid, placeholder } }: SignatureProps) => {
    return (
        <Controller
            name={name || _uid}
            render={({ field }) => (
                <StoryblokSignatureComponent
                    placeholder={placeholder}
                    onChange={field.onChange}
                />
            )}
            rules={{ required: true }}
        />
    );
};

export default memo(Signature);
